import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';
import { PrescriptionSettings, UpdatePrescriptionSettingsDto } from '../types/settings.types';

export const settingsApi = {
  getPrescriptionSettings: async (): Promise<PrescriptionSettings> => {
    const response = await apiClient.get<PrescriptionSettings>(
      API_ENDPOINTS.PRESCRIPTION_SETTINGS
    );
    return response.data;
  },

  updatePrescriptionSettings: async (
    data: UpdatePrescriptionSettingsDto
  ): Promise<PrescriptionSettings> => {
    const response = await apiClient.put<PrescriptionSettings>(
      API_ENDPOINTS.PRESCRIPTION_SETTINGS,
      data
    );
    return response.data;
  },
};

